{
  "static-content-become-partner": {
    "buttons": {
      "be-partner": "Trở thành Đối tác"
    },
    "text": {
      "title": "Bạn là chủ thẩm mỹ viện? Trực tuyến hóa ngay hôm nay!",
      "description": "Đừng bỏ lỡ cơ hội. Hãy tải App dùng thử để thấy sự thay đổi tích cực trong việc quản lý Salon. Với giao diện thân thiện và khả năng tùy chỉnh, phần mềm Beauty Pro giúp nâng cao sự hài lòng của khách hàng với salon của bạn!"
    }
  }
}
